import {
  GET_THRESHOLD_SUCCESS,
  GET_THRESHOLD_FAIL,
  GET_THRESHOLD,
  GET_DYNAMIC_THRESHOLD,
  GET_DYNAMIC_THRESHOLD_SUCCESS,
  GET_DYNAMIC_THRESHOLD_FAIL,
  POST_ALERT_SETUP,
  POST_ALERT_SETUP_FAIL,
  POST_DISABLE_THRESHOLD_ALERTS,
  POST_ENABLE_THRESHOLD_ALERTS,
  POST_DISABLE_THRESHOLD_ALERTS_FAIL,
  POST_ENABLE_THRESHOLD_ALERTS_FAIL,
  GET_SERVICE_QUOTA_THRESHOLD,
  GET_SERVICE_QUOTA_THRESHOLD_SUCCESS,
  GET_SERVICE_QUOTA_THRESHOLD_FAIL,
  GET_QUOTA_MASTER_RESOURCES,
  GET_QUOTA_MASTER_RESOURCES_SUCCESS,
  GET_QUOTA_MASTER_RESOURCES_FAIL,
  DEPLOY_MASTER_RESOURCE_QUOTA_ALERTS,
  DEPLOY_MASTER_RESOURCE_QUOTA_ALERTS_SUCCESS,
  DEPLOY_MASTER_RESOURCE_QUOTA_ALERTS_FAIL,
  UPDATE_QUOTA_MASTER_RESOURCE_ALERTS_CONFIG,
  UPDATE_QUOTA_MASTER_RESOURCE_ALERTS_CONFIG_SUCCESS,
  UPDATE_QUOTA_MASTER_RESOURCE_ALERTS_CONFIG_FAIL,
  GET_DEPLOYED_SERVICE_QUOTA_ALERTS,
  GET_DEPLOYED_SERVICE_QUOTA_ALERTS_FAIL,
  GET_DEPLOYED_SERVICE_QUOTA_ALERTS_SUCCESS,
  UPDATE_DEPLOYED_ALERT,
  UPDATE_DEPLOYED_ALERT_SUCCESS,
  UPDATE_DEPLOYED_ALERT_FAIL
} from "./actionTypes";

// services data

export const getThreshold = (data) => ({
  type: GET_THRESHOLD,
  payload: data
})

export const getThresholdSuccess = threshold => ({
  type: GET_THRESHOLD_SUCCESS,
  payload: threshold,
})

export const getThresholdFail = error => ({
  type: GET_THRESHOLD_FAIL,
  payload: error,
})

export const getDynamicThreshold = (data) => ({
  type: GET_DYNAMIC_THRESHOLD,
  payload: data
})

export const getDynamicThresholdSuccess = threshold => ({
  type: GET_DYNAMIC_THRESHOLD_SUCCESS,
  payload: threshold,
})

export const getDynamicThresholdFail = error => ({
  type: GET_DYNAMIC_THRESHOLD_FAIL,
  payload: error,
})

export const postAlertSetup = (alerts, history) => {
  return {
    type: POST_ALERT_SETUP,
    payload: { alerts, history }
  }
}

export const postAlertSetupFail = error => ({
  type: POST_ALERT_SETUP_FAIL,
  payload: error,
})

export const postDisableThresholdAlerts = (alerts) => {
  return {
    type: POST_DISABLE_THRESHOLD_ALERTS,
    payload: { alerts }
  }
}

export const postEnableThresholdAlerts = (alerts) => {
  return {
    type: POST_ENABLE_THRESHOLD_ALERTS,
    payload: { alerts }
  }
}

export const postEnableThresholdAlertsFail = error => ({
  type: POST_ENABLE_THRESHOLD_ALERTS_FAIL,
  payload: error,
})

export const postDisableThresholdAlertsFail = error => ({
  type: POST_DISABLE_THRESHOLD_ALERTS_FAIL,
  payload: error,
})


export const getQuotaThreshold = () => ({
  type: GET_SERVICE_QUOTA_THRESHOLD,
})

export const getQuotaThresholdSuccess = threshold => ({
  type: GET_SERVICE_QUOTA_THRESHOLD_SUCCESS,
  payload: threshold,
})

export const getQuotaThresholdFail = error => ({
  type: GET_SERVICE_QUOTA_THRESHOLD_FAIL,
  payload: error,
})

export const getQuotaMasterResources = () => ({
  type: GET_QUOTA_MASTER_RESOURCES,
})

export const getQuotaMasterResourcesSuccess = master_resources => ({
  type: GET_QUOTA_MASTER_RESOURCES_SUCCESS,
  payload: master_resources,
})

export const getQuotaMasterResourcesFail = error => ({
  type: GET_QUOTA_MASTER_RESOURCES_FAIL,
  payload: error,
})

export const deployMasterResourceQuotaAlerts = (data) => ({
  type: DEPLOY_MASTER_RESOURCE_QUOTA_ALERTS,
  payload: data
})

export const deployMasterResourceQuotaAlertsSuccess = () => ({
  type: DEPLOY_MASTER_RESOURCE_QUOTA_ALERTS_SUCCESS,
})

export const deployMasterResourceQuotaAlertsFail = error => ({
  type: DEPLOY_MASTER_RESOURCE_QUOTA_ALERTS_FAIL,
  payload: error,
})

export const updateQuotMasterResourceConfig = (data) => ({
  type: UPDATE_QUOTA_MASTER_RESOURCE_ALERTS_CONFIG,
  payload: data
})


export const updateQuotMasterResourceConfigSuccess = () => ({
  type: UPDATE_QUOTA_MASTER_RESOURCE_ALERTS_CONFIG_SUCCESS,
})

export const updateQuotMasterResourceConfigFail = error => ({
  type: UPDATE_QUOTA_MASTER_RESOURCE_ALERTS_CONFIG_FAIL,
  payload: error,
})


export const getAllDeployedServiceQuotaAlerts = () => ({
  type: GET_DEPLOYED_SERVICE_QUOTA_ALERTS,
})

export const deployServiceQuotaAlertsSuccess = (data) => ({
  type: GET_DEPLOYED_SERVICE_QUOTA_ALERTS_SUCCESS,
  payload: data,
})

export const deployServiceQuotaAlertsFail = (error) => ({
  type: GET_DEPLOYED_SERVICE_QUOTA_ALERTS_FAIL,
  payload: error,
})

export const updateDeployedAlert = (data) => ({
  type: UPDATE_DEPLOYED_ALERT,
  payload: data
})

export const updateDeployedAlertSuccess = () => ({
  type: UPDATE_DEPLOYED_ALERT_SUCCESS,
})

export const updateDeployedAlertFail = (error) => ({
  type: UPDATE_DEPLOYED_ALERT_FAIL,
  payload: error,
})